import React, { useState, useEffect } from 'react';
import { useAppContext } from '../context/AppContext';  
import SideMenu from "../components/SideMenu";
import Profile from "../components/Profile";
import SchedulePage from "./SchedulePage";
import Chat from "../components/Chat";
import LeaderPanel from "../components/LeaderPanel";
import AdminPanel from "../components/AdminPanel";
import "./css/homepage.css";
import axios from 'axios';
import config from "../config"; // Импортируем API_URL

const HomePage = () => {
  const { weekType, currentClass, nextClass, timeUntilNextClass } = useAppContext();
  const [activePage, setActivePage] = useState("home"); 
  const [groupId, setGroupId] = useState(null);
  const [userId, setUserId] = useState(null);
  const [username, setUsername] = useState("");

  useEffect(() => {
    const fetchUserInfo = async () => {
      const token = localStorage.getItem('token');
      if (!token) return;

      try {
        const response = await axios.get(`${config.API_URL}/user_info`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUserId(response.data.user_id);
        setUsername(response.data.username);
        setGroupId(response.data.group_id);
      } catch (error) {
        console.error("Ошибка загрузки информации о пользователе:", error);
      }
    };

    fetchUserInfo();
  }, []);

  return (
    <>
      <header className='header'>
        <SideMenu setActivePage={setActivePage} />
      </header>
      <main>
        {activePage === "home" && (
          <div id="main">
            <p className="sliding-secondary-text">Добро пожаловать на главную страницу!</p>
            <p className="sliding-secondary-text">Тип недели: {weekType}</p>
            <p className="sliding-secondary-text">{timeUntilNextClass}</p>

            {currentClass ? (
              <p className="sliding-secondary-text">
                Сейчас идет: {currentClass.subject} ({currentClass.start_time} - {currentClass.end_time}) в кабинете {currentClass.classroom}
              </p>
            ) : nextClass ? (
              <p className="sliding-secondary-text">
                Следующая пара: {nextClass.subject} ({nextClass.start_time} - {nextClass.end_time}) в кабинете {nextClass.classroom}
              </p>
            ) : (
              <p className="sliding-secondary-text">Сегодня пар больше нет</p>
            )}
          </div>
        )}
        {activePage === "profile" && <Profile />}
        {activePage === "schedule" && <SchedulePage />}
        {activePage === "chat" && <Chat groupId={groupId} userId={userId} username={username} />}
        {activePage === "admin" && <AdminPanel />} 
        {activePage === "leader" && <LeaderPanel />} 
      </main>
    </>
  );
};

export default HomePage;
